<div class="game-score__container" *transloco="let t; prefix: 'pages.game-component'">
  @if (themeService.header().hasCloseButton) {
    <app-nav-button icon="close" (clickEvent)="onCloseClicked()" class="game-score__back-button" />
  }
  @if (gameInterfaceState !== GameInterfaceState.GameStarted) {
    <div class="game-score__content">
      <div class="game-score__title">
        <app-game-title
          [wordmarkUrl]="themeService.wordmarkUrl(gameId)"
          [title]="gameName ?? ''"
        ></app-game-title>
      </div>
    </div>
  }
  @if (gameInterfaceState === GameInterfaceState.GameStarted) {
    <div class="game-score__content">
      <div class="game-score__pill-content">
        @if (!themeService.header().inlinePrizePill) {
          <div class="game-score__row">
            <div [ngStyle]="prizeStyles | theme" class="game-score__prize">
              @if (!tournamentId) {
                <span>{{ t("prize") }} </span>

                @if (reward?.primary?.icon && reward?.primary?.iconPosition === "start") {
                  <app-currency-icon [icon]="reward!.primary.icon!" sizeCss="--icon-medium" />
                }
                {{ primaryRewardLabel }}
                @if (reward?.primary?.icon && reward?.primary?.iconPosition === "end") {
                  <app-currency-icon [icon]="reward!.primary.icon!" sizeCss="--icon-medium" />
                }

                @if (reward?.secondary?.text && hasSecondaryCurrency) {
                  <span class="secondary-span">
                    {{ "(" }}
                    <span class="secondary-icon-span">
                      @if (reward?.secondary?.icon && reward?.secondary?.iconPosition === "start") {
                        <app-currency-icon
                          [icon]="reward!.secondary.icon!"
                          sizeCss="--icon-medium"
                        />
                      }
                      {{ reward?.secondary?.text }}
                      @if (reward?.secondary?.icon && reward?.secondary?.iconPosition === "end") {
                        <app-currency-icon
                          [icon]="reward!.secondary.icon!"
                          sizeCss="--icon-medium"
                        />
                      }
                    </span>
                    {{ ")" }}
                  </span>
                }
              }

              @if (tournamentId) {
                <app-tournament-pill [tournamentLabel]="tournamentLabel" [state]="'active'" />
              }
            </div>
          </div>
        }
        <div class="game-score__row">
          @if (showScore) {
            <div class="game-pill" [ngStyle]="scorePillStyles | theme">
              <app-icon
                icon="points"
                colorCss="'var(--game-header-prize-fill)'"
                sizeCss="--icon-large"
              ></app-icon>
              <div class="game-pill__labels">
                <div class="game-pill__score">{{ score }}</div>
                @if (themeService.header().hasPillSubLabel) {
                  <div [ngStyle]="scorePillSubLabelStyles | theme">{{ t("score") }}</div>
                }
              </div>
            </div>
          }

          @if (primaryRewardLabel && themeService.header().inlinePrizePill && !tournamentId) {
            <div class="game-pill" [ngStyle]="scorePillStyles | theme">
              <div class="game-pill__labels">
                <div class="game-pill__reward">
                  @if (reward?.primary?.icon && reward?.primary?.iconPosition === "start") {
                    <app-currency-icon [icon]="reward!.primary.icon!" sizeCss="--icon-medium" />
                  }
                  {{ primaryRewardLabel }}
                  @if (reward?.primary?.icon && reward?.primary?.iconPosition === "end") {
                    <app-currency-icon [icon]="reward!.primary.icon!" sizeCss="--icon-medium" />
                  }

                  @if (reward?.secondary?.text && hasSecondaryCurrency) {
                    <span class="secondary-span">
                      {{ "(" }}
                      <span class="secondary-icon-span">
                        @if (
                          reward?.secondary?.icon && reward?.secondary?.iconPosition === "start"
                        ) {
                          <app-currency-icon
                            [icon]="reward!.secondary.icon!"
                            sizeCss="--icon-medium"
                          />
                        }
                        {{ reward?.secondary?.text }}
                        @if (reward?.secondary?.icon && reward?.secondary?.iconPosition === "end") {
                          <app-currency-icon
                            [icon]="reward!.secondary.icon!"
                            sizeCss="--icon-medium"
                          />
                        }
                      </span>
                      {{ ")" }}
                    </span>
                  }
                </div>

                @if (themeService.header().hasPillSubLabel) {
                  <div [ngStyle]="currencyPillSubLabelStyles | theme">{{ t("prize") }}</div>
                }
              </div>
            </div>
          }

          <div class="game-pill" [ngStyle]="timerPillStyles | theme">
            <app-icon
              icon="stopwatch"
              colorCss="'var(--game-header-prize-fill)'"
              sizeCss="--icon-large"
            ></app-icon>

            <div class="game-pill__labels">
              <div class="game-pill__timer">
                <span class="game-score__stack">
                  <!-- Ghost span to reserve space -->
                  @if (countdown) {
                    <span class="game-score__ghost" aria-hidden="true">
                      {{ countdown | timeFormatGhost }}
                    </span>
                  }

                  <!-- Actual countdown display -->
                  @if (countdown) {
                    <span
                      class="game-score__visible"
                      [ngClass]="{ 'game-score__danger': countdown < 60 }"
                    >
                      {{ countdown | timeFormat }}
                    </span>
                  }
                  @if (isEnded()) {
                    <span>{{ t("countdown-ended") }}</span>
                  }
                </span>
              </div>
              @if (themeService.header().hasPillSubLabel) {
                <div [ngStyle]="scorePillSubLabelStyles | theme">{{ t("countdown") }}</div>
              }
            </div>
          </div>
        </div>
      </div>
    </div>
  }
  @if (themeService.header().hasGameHelpButton) {
    <app-nav-button
      icon="info-circle"
      (clickEvent)="onCheatSheetClicked()"
      class="info-circle-icon"
    />
  }
</div>
